var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.video.file)?_c('div',{staticClass:"mt-16 w-80 mx-auto",staticStyle:{"height":"600px"}},[_c('video',{staticClass:"ma-auto",staticStyle:{"object-fit":"fill"},attrs:{"id":"glassVideo","width":"100%","height":"100%","controls":""}},[_c('source',{attrs:{"src":_vm.video.file}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }